<template>
  <div class="beta_banner">
    <div class="left_section">
      <BaseIcon icon="$mdiBullhornOutline" color="white" />
      <BaseChip type="tertiary" small v-text="$t('beta_banner.badge')" />
      <div class="message" v-text="$t('beta_banner.message')" />
    </div>
    <div class="right_section">
      <a
        href="https://beta-bo.devngo.fr/"
        target="_blank"
        rel="noopener noreferrer"
        class="cta_link"
      >
        <span v-text="$t('beta_banner.cta')" />
        <BaseIcon icon="$mdiArrowRightThick" color="white" small />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheBetaBanner",
};
</script>

<style lang="scss" scoped>
.beta_banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 24px;
  margin-bottom: 18px;
  background: linear-gradient(135deg, #2536cc 0%, #702dde 100%);

  .left_section {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    flex: 1 1 auto;
    min-width: 0;

    .message {
      color: #fff;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .right_section {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: none;

    .cta_link {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      text-decoration: underline;
      text-decoration-color: rgba(255, 255, 255, 0.5);
      white-space: nowrap;

      &:hover {
        text-decoration-color: #fff;
      }
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 16px;

    .left_section {
      width: 100%;
    }

    .right_section {
      width: 100%;
    }
  }
}
</style>
